





































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import KeyValue from "@/components/molecules/DisplayKeyValue/index.vue";
import KeyValueGroup from "@/components/molecules/DisplayKeyValueGroup/index.vue";
import InvoiceTable from "@/components/organisms/InvoiceTable/index.vue";
import ModalCreditcard from "@/components/organisms/modal/ModalCreditcard/index.vue";
import { ModalProgrammatic } from "buefy/dist/components/modal";
import CreditCardIcon from "@/components/atoms/CreditCardIcon/index.vue";

@Component({
  components: { KeyValue, KeyValueGroup, InvoiceTable, CreditCardIcon },
})
export default class Contrats extends Vue {

  @Prop() private contractInfo!: any[];
  @Prop() private invoices!: any[];
  @Prop() private currentSource!: any;
  @Prop() private handleOnSelectYearChange!: (year: string) => any ;

  private isTouchedInvoiceTab = false;

  public openModal() {
    ModalProgrammatic.open({
      parent: this,
      component: ModalCreditcard,
      hasModalCard: true,
      props: {
        currentSource: this.currentSource,
      },
    });
  }

  private handleOnTabChange(index: number) {
    if (this.isTouchedInvoiceTab) {
      return;
    }
    if (index === 1) { // invoiceTab
      try {
        const currentYear = (new Date()).getFullYear().toString();
        this.handleOnSelectYearChange(currentYear);
        this.isTouchedInvoiceTab = true;
      } catch (err) {
        console.log(err);
      }
    }
  }

  get cardInfo(): any {
    let val = "なし";
    if (this.currentSource) {
      const { last4, exp_year, exp_month } = this.currentSource;
      val = ` 下4桁  ${last4} (有効期限: ${exp_year}/${exp_month})`;
    }
    return { key: "ご登録中のカード", text: val };
  }
}
